/**
 * 画像読み込み
 * {name:アセット識別ID, file:ファイルパス}
 * 
 * スプライトシート読み込み
 * {name:アセット識別ID, file:ファイルパス, w:ひとコマの幅、h:ひとコマの高さ}
 * 
 * Audio
 * {name:アセット識別ID, file:[ファイルパス]}
 */

const imgGame1 = './assets/img/game/';
const imgGame2 = './assets/img/game2/';

const audioGame1 = './assets/audio/game/';
const audioGame2 = './assets/audio/game2/';

const audio_ext = window.navigator.userAgent.match(/Android/) ? ".ogg" : ".mp3";


// 共通で最初に読み込んでおくアセット
const commonAssets = {
    image: [
    ],
    spritesheet: [
    ]
};

// ゲーム進行の裏で読み込むアセット
const commonSubAssets = {
    image: [
    ],
    spritesheet: [
    ]
}


// 各ゲームごとのアセット
const assets = {

    game1: {

        image: [
            {name:'playing_score', file:`${imgGame1}playing/score/text_score.png`},
            {name:'playing_ripple', file:`${imgGame1}playing/egg/ripple.png`},
            {name:'telop_start', file:`${imgGame1}playing/telop/letsstart.png`},
            {name:'telop_timeup', file:`${imgGame1}playing/telop/timeup.png`},
            {name:'get_light', file:`${imgGame1}playing/get/light.png`},
            {name:'get_scoreup', file:`${imgGame1}playing/get/scoreup.png`},
            {name:'get_star', file:`${imgGame1}playing/get/star.png`},
            {name:'clear_dragon1', file:`${imgGame1}clear/dragon1.png`},
            {name:'clear_dragon2', file:`${imgGame1}clear/dragon2.png`},
            {name:'clear_light', file:`${imgGame1}clear/light.png`},
            {name:'clear_score', file:`${imgGame1}clear/score.png`},
            {name:'clear_shimajiro', file:`${imgGame1}clear/shimajiro.png`},

            {name:'ans_apple', file:`${imgGame1}playing/answer/apple.png`},
            {name:'ans_banana', file:`${imgGame1}playing/answer/banana.png`},
            {name:'ans_lemon', file:`${imgGame1}playing/answer/lemon.png`},
            {name:'ans_grapes', file:`${imgGame1}playing/answer/grapes.png`},
            {name:'ans_cherries', file:`${imgGame1}playing/answer/cherries.png`},
            {name:'ans_kiwi', file:`${imgGame1}playing/answer/kiwi.png`},
            {name:'ans_melon', file:`${imgGame1}playing/answer/melon.png`},
            {name:'ans_peach', file:`${imgGame1}playing/answer/peach.png`},
            {name:'ans_strawberry', file:`${imgGame1}playing/answer/strawberry.png`},
            {name:'ans_mango', file:`${imgGame1}playing/answer/mango.png`},
        ],
        spritesheet: [
            {name:'playing_egg', file:`${imgGame1}playing/egg/egg.png`, w:220, h:280},
            {name:'playing_fruit', file:`${imgGame1}playing/egg/fruit.png`, w:220, h:280},
            {name:'playing_score_number', file:`${imgGame1}playing/score/number.png`, w:42, h:57},
            {name:'get_break1', file:`${imgGame1}playing/egg/break1.png`, w:240, h:240},
            {name:'get_break2', file:`${imgGame1}playing/egg/break2.png`, w:240, h:240},
            {name:'get_dragon', file:`${imgGame1}playing/get/dragon.png`, w:480, h:480},
            {name:'get_dragon_s', file:`${imgGame1}playing/get/dragon_s.png`, w:140, h:140},
            {name:'clear_score_number', file:`${imgGame1}clear/number.png`, w:108, h:160},
        ]
    },

    game2: {

        image: [
            {name:'dragon', file:`${imgGame2}dragon.png`},
            {name:'dragon_shadow', file:`${imgGame2}dragon_shadow.png`},
            {name:'title', file:`${imgGame2}start/title.png`},

            {name:'question', file:`${imgGame2}playing/question.png`},
            {name:'btn_setsumei', file:`${imgGame2}playing/btn_setsumei.png`},
            {name:'grapes', file:`${imgGame2}playing/grapes.png`},
            {name:'ico_hand', file:`${imgGame2}playing/ico_hand.png`},
            {name:'rec_ripple', file:`${imgGame2}playing/rec_ripple.png`},
            {name:'btn_retry', file:`${imgGame2}playing/btn_retry.png`},
        ],
        spritesheet: [
            {name:'kira', file:`${imgGame2}playing/kira.png`, w:570, h:452},
            {name:'dragon_egg', file:`${imgGame2}start/tamago.png`, w:262, h:230},
            {name:'dragon_kira', file:`${imgGame2}dragon_kira.png`, w:570, h:454},
            {name:'shimajiro', file:`${imgGame2}playing/shimajiro.png`, w:400, h:440},
            {name:'btn_rec', file:`${imgGame2}playing/btn_rec.png`, w:255, h:255},
        ]
    }
};

const soundAssets = {

    game1: {

        // fruit
        na_apple: {src:[`${audioGame1}na/fruit/apple${audio_ext}`]},
        na_banana: {src:[`${audioGame1}na/fruit/banana${audio_ext}`]},
        na_lemon: {src:[`${audioGame1}na/fruit/lemon${audio_ext}`]},
        na_cherries: {src:[`${audioGame1}na/fruit/cherries${audio_ext}`]},
        na_grapes: {src:[`${audioGame1}na/fruit/grapes${audio_ext}`]},
        na_kiwi: {src:[`${audioGame1}na/fruit/kiwi${audio_ext}`]},
        na_melon: {src:[`${audioGame1}na/fruit/melon${audio_ext}`]},
        na_peach: {src:[`${audioGame1}na/fruit/peach${audio_ext}`]},
        na_strawberry: {src:[`${audioGame1}na/fruit/strawberry${audio_ext}`]},
        na_mango: {src:[`${audioGame1}na/fruit/mango${audio_ext}`]},

        // NA
        na_start: {src:[`${audioGame1}na/start${audio_ext}`]},
        na_timeup: {src:[`${audioGame1}na/timeup${audio_ext}`]},
        na_yey: {src:[`${audioGame1}na/yey${audio_ext}`]},

        // se
        se_bgm: {src:[`${audioGame1}se/bgm${audio_ext}`], loop: true, volume:0.4},
        se_birth: {src:[`${audioGame1}se/birth${audio_ext}`], volume:0.6},
        se_correct: {src:[`${audioGame1}se/correct${audio_ext}`], volume:0.2},
        se_failed: {src:[`${audioGame1}se/failed${audio_ext}`], volume:0.4},
    },

    game2: {

        // title
        title_na1: {src:[`${audioGame2}title/na1${audio_ext}`]},
        title_na2: {src:[`${audioGame2}title/na2${audio_ext}`]},

        // kaisetsu
        kaisetsu_na1: {src:[`${audioGame2}kaisetsu/na1${audio_ext}`]},
        kaisetsu_na2: {src:[`${audioGame2}kaisetsu/na2${audio_ext}`]},
        kaisetsu_na3: {src:[`${audioGame2}kaisetsu/na3${audio_ext}`]},
        kaisetsu_na4: {src:[`${audioGame2}kaisetsu/na4${audio_ext}`]},
        kaisetsu_na5: {src:[`${audioGame2}kaisetsu/na5${audio_ext}`]},
        kaisetsu_na6: {src:[`${audioGame2}kaisetsu/na6${audio_ext}`]},
        kaisetsu_na7: {src:[`${audioGame2}kaisetsu/na7${audio_ext}`]},
        kaisetsu_na8: {src:[`${audioGame2}kaisetsu/na8${audio_ext}`]},
        
        // recording
        rec_na1: {src:[`${audioGame2}recording/na1${audio_ext}`]},
        rec_na2: {src:[`${audioGame2}recording/na2${audio_ext}`]},
        rec_na3: {src:[`${audioGame2}recording/na3${audio_ext}`]},
        rec_na4: {src:[`${audioGame2}recording/na4${audio_ext}`]},
        na_yey: {src:[`${audioGame2}recording/yey${audio_ext}`]},

        // se
        se_bgm: {src:[`${audioGame2}title/bgm${audio_ext}`], volume:0.4},
        se_picon: {src:[`${audioGame2}common/se_picon${audio_ext}`], volume:0.6},
    }
};


export {commonAssets, commonSubAssets, assets, soundAssets};